import { ButtonBase, Divider } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { BinIcon } from "../../../Icons";
import { PostcodeLabel } from "../../../Layers/RouteLabelLayer/PostcodeLabel";
import { View } from "../../../Base";
import clsx from "clsx";

const useStyles = makeStyles({
  container: {
    display: "flex",
    direction: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    minWidth: "70px",
    marginRight: "10px",
  },
  label: {
    width: "32px",
    marginRight: "10px",
  },
  flex: {
    display: "flex",
  },
  flexGrow: {
    flexGrow: 1,
  },
  iconContainer: {
    marginLeft: "10px",
  },
});

export const PostcodeLine = ({
  lineNo,
  postcode,
  onDelete,
  deleteDisabled = false,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.labelContainer}>
        <View className={clsx(styles.label, styles.flex)}>
          <PostcodeLabel postcode={lineNo} className={styles.label} />
        </View>
        <View className={styles.flex}>{postcode}</View>
      </View>
      <View className={styles.flexGrow}>
        <Divider />
      </View>
      <View className={styles.iconContainer}>
        <ButtonBase
          onClick={() => onDelete && onDelete()}
          disabled={deleteDisabled}
        >
          <BinIcon disabled={deleteDisabled} />
        </ButtonBase>
      </View>
    </View>
  );
};
